export const PHONE_NOTIFICATION_PREFERENCES = 'phone-notification-preferences'